<div class="form" [formGroup]="form" *ngIf="isAllDataLoaded">
  <app-searchable-select
    *ngIf="links"
    formControlName="addonLinkId"
    [label]="'signatures.link' | translate"
    [options]="links.links"
    [displayWith]="linkLabel"
    [valueWith]="linkValue"
    [searchWith]="linkSearch"
    [emptyLabel]="'none' | translate"
    [emptyValue]="null"
  ></app-searchable-select>

  <app-searchable-select
    *ngIf="banners"
    formControlName="addonBannerId"
    [label]="'signatures.banner' | translate"
    [options]="banners.banners"
    [displayWith]="bannerLabel"
    [valueWith]="bannerValue"
    [searchWith]="bannerSearch"
    [emptyLabel]="'none' | translate"
    [emptyValue]="null"
  ></app-searchable-select>

  <app-searchable-select
    *ngIf="banners"
    formControlName="addonAdditionalBannerId"
    [label]="'signatures.additionalBanner' | translate"
    [options]="banners.banners"
    [displayWith]="bannerLabel"
    [valueWith]="bannerValue"
    [searchWith]="bannerSearch"
    [emptyLabel]="'none' | translate"
    [emptyValue]="null"
  ></app-searchable-select>

  <app-searchable-select
    *ngIf="disclaimers"
    formControlName="addonDisclaimerId"
    [label]="'signatures.disclaimer' | translate"
    [options]="disclaimers.disclaimers"
    [displayWith]="disclaimerLabel"
    [valueWith]="disclaimerValue"
    [searchWith]="disclaimerSearch"
    [emptyLabel]="'none' | translate"
    [emptyValue]="null"
  ></app-searchable-select>
</div>
